export const iconFontAwesomeDesignFloppyDisk = (
	<i className="fa-solid fa-floppy-disk"></i>
);
